module.exports = __webpack_public_path__ + "static/media/1-Front-Ground.870780e1.webp";